import React from "react";
import { withRouter } from "react-router-dom";

const CompanyAuth = (props) => {
    const { children } = props;
    return <React.Fragment>{children}</React.Fragment>;
};

export default withRouter(CompanyAuth);
